import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../../services/customer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { DashboardService } from '../../../services/dashboard.service';
import { CommonfilterService } from '../../../services/commonfilter.service';
import { DateFormatPipe } from '../../../pipes/dateFormat.pipe';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-home',
  templateUrl: './account-home.component.html',
  styleUrls: ['./account-home.component.css']
})
export class AccountHomeComponent implements OnInit {

  collapsed_active;
  collapsed_payment;
  collapsed_cust;
  collapsed_topten;
  accountTo: any;
  accountFrom: any;
  sectors: any = [];
  locations: any = [];
  filterParams: string;
  cust_currentLogins: any;
  cust_mob_downloads: any;
  cust_todaySignups: any;
  acc_currentlogins: any;
  acc_todaySignups: any;
  accCount: any = {};
  firstDay: any;
  lastDay: any;
  todate_customer: any;
  fromdate_customer: any;
  fromdate: any;
  todate: any;
  filterParamCustomer: string;
  customer_web: number;
  customer_mob: number;
  newlySigned: any;
  waitlist: number;
  topten: any = [];
  topten_serviceSector = 0; active_serviceSector = 0;
  activeInactive_Servicesector = 0;
  topten_location = 0; active_location = 0;
  payumoney: any;
  paytm: any;
  paymentData: any = {};
  accountData: any = {};
  customer_ios: number;
  customer_android: number;
  activeInactiveParams: string;
  activeAccountCount: any;
  inactiveAccountCount: any;
  newlysignedfilterParams = '';
  showDate: false;
  dateRange;
  account;
  payment_account;
  constructor(
    private customerService: CustomerService,
    private accountService: AccountService,
    private dashboardService: DashboardService,
    private commonservice: CommonfilterService,
    private datepipe: DateFormatPipe,
    private router: Router, private route: ActivatedRoute,

  ) {
    this.setDate();

  }

  ngOnInit() {
    this.account = true;
    this.payment_account = true;
    // this.FetchAccountAnalytics();
    // this.FetchConsumerAnalytics();
    // this.getLocations();
    this.getServiceSectors();
    this.getActiveInactiveClaimedAcccountCounts(0);
    this.getCustomerCountwithFilter(this.filterParamCustomer);
    this.newlySignedUpAccounts(this.filterParamCustomer);
    this.getPaymentGatewayCount();

  }
  setDate() {

    const date = new Date();
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.fromdate_customer = this.fromdate = new Date(this.firstDay).toISOString().split('T')[0];
    this.todate_customer = this.todate = new Date(this.lastDay).toISOString().split('T')[0];
    this.filterParamCustomer = 'from=' + this.fromdate_customer + '&to=' + this.todate_customer;
    this.accountFrom = this.datepipe.monthTransform(this.fromdate);
    this.accountTo = this.datepipe.monthTransform(this.todate);

  }
  FetchAccountAnalytics() {
    this.newlysignedfilterParams = '?isIncludeTest=' + this.account + '&isFilterByDate=false';
    this.accountService.getAccountAnalyticsBySector(0,this.newlysignedfilterParams).subscribe(

      (data) => {
        console.log(data);
        this.acc_currentlogins = data.loginAnalytics.accountInSession;
        this.acc_todaySignups = data.signupAnalytics.todaySignupAcc;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
        }


      });
  }
  getServiceSectors() {
    this.commonservice.getServiceSectors()
      .subscribe(data => this.sectors = data);
  }
  // getLocations() {
  //   this.commonservice.getLocations()
  //   .subscribe(data => this.locations = data);
  // }
  getActiveInactiveClaimedAcccountCounts(activeInactive_Servicesector) {
    if (this.activeInactive_Servicesector === 0) {
      this.filterParams = 'isIncludeTest=' + this.account;
    } else {
      this.filterParams ='&isIncludeTest=' + this.account + '&' + this.commonservice.createfilterParams('activeinactive');
      console.log(this.filterParams)
    }
    this.accountService.getActiveInactiveAccountCount(activeInactive_Servicesector,this.filterParams)
    .subscribe(res => {
      console.log()
      this.activeAccountCount = res[0];
      this.inactiveAccountCount = res[1];

    });
  }
  getAccounts(status) {
    this.accountService.setAccountStatusFilter(status);
    if (this.activeInactive_Servicesector === 0) {
      this.accountData.filterParam = 'accntStatus-eq=' + status + '&isIncludeTest=' + this.account;
    } else {
      this.activeInactiveParams = this.commonservice.createfilterParams('activeinactive');
      this.accountData.filterParam = 'accntStatus-eq=' + status + '&isIncludeTest=' + this.account + '&' +this.activeInactiveParams;
    }

    this.accountData.flag = true;
    this.accountService.storeAccountData(this.accountData);
    this.router.navigate(['../list'], { relativeTo: this.route });
  }
  getNewlySignedUpAccounts(_count) {
    this.accountData = {};
    let newlysignedfilterParam = '';
    if (this.topten_serviceSector === 0) {
      newlysignedfilterParam = 'createdDate-ge=' + this.fromdate + '&' + 'createdDate-le=' + this.todate;
    } else {
      newlysignedfilterParam = 'serviceSector-eq=' + this.topten_serviceSector + '&' +
        'createdDate-ge=' + this.fromdate + '&' + 'createdDate-le=' + this.todate;
    }
    this.accountData.filterParam = newlysignedfilterParam;
    this.accountData.flag = true;
    this.accountData.count = _count;
    this.accountService.setDomainFilterValue(this.topten_serviceSector);
    this.accountService.setCreatedOperator('inbetween');
    this.accountService.setCreatedFromDate(this.fromdate);
    this.accountService.setCreatedToDate(this.todate);
    this.accountService.storeAccountData(this.accountData);
    // this.router.navigateByUrl('../../../filter', {skipLocationChange: true}).then(() =>
    this.router.navigate(['../list'], { relativeTo: this.route });

  }

  getAccountsByCategory(category, _count) {
    const filterParam = 'category=' + category;
    this.accountData.filterParam = filterParam;
    this.accountData.flag = true;
    this.accountData.count = _count;
    this.accountService.setCategoryFilterValue(category);
    this.accountService.storeAccountData(this.accountData);
    this.router.navigate(['../list'], { relativeTo: this.route });

  }
  // paymentgateway
  getPaymentGatewayCount(): any {
    let paymentfilterParam = '';
    paymentfilterParam = '?isIncludeTest=' + this.payment_account;
    this.accountService.getpaymentGatewayCount(paymentfilterParam)
      .subscribe(data => {
        this.payumoney = data[0];
        this.paytm = data[1];
      });
  }
  getCustomerCount() {
    const custParam = this.getFilterParamOfCustomer();
    this.getCustomerCountwithFilter(custParam);


  }
  getFilterParamOfCustomer() {
    return this.commonservice.createFilterForCustomer('customers_accountSUmmary');

  }
  getCustomerCountwithFilter(custFilterParam) {
    this.customerService.getCustomerWebAndMobCount(custFilterParam)
      .subscribe(data => {
        console.log(data);
        this.customer_ios = data[0];
        this.customer_android = data[1];
        this.customer_web = data[2];
      });
  }

  newlySignedUpAccounts(filterParam) {
    this.accountService.getTopTenAccountSummary(filterParam)
      .subscribe(data => {
        this.newlySigned = parseInt(data[0].activeCount, 10) + parseInt(data[0].inActiveCount, 10);
        this.waitlist = data[1];
      });
    this.accountService.getTopTenAccount(filterParam)
      .subscribe(data => {
        this.topten = data;
      });

  }

  newlysignedUp() {
    const accountParam = this.getNewlySignedCount();
    this.newlySignedUpAccounts(accountParam);

  }
  getNewlySignedCount() {
    return this.commonservice.filterParams_without_operators('top_ten_account');
  }
  setPayUMoney() {
   
    this.paymentData.tabindex = 0;
    this.paymentData.filter = '&isIncludeTest=' + this.payment_account;
    this.paymentData.payu = true;
    this.paymentData.payuVerified = true;
    this.paymentData.payTm = true;
    this.paymentData.payTmVerified = true;
    this.accountService.setPaymentData(this.paymentData);
    this.router.navigate(['../../payment'], { relativeTo: this.route });
  }
  setPayTM() {
   
    this.paymentData.tabindex = 1;
    this.paymentData.filter = '&isIncludeTest=' + this.payment_account;
    this.paymentData.payTm = true;
    this.paymentData.payTmVerified = true;
    this.paymentData.payu = true;
    this.paymentData.payuVerified = true;
    this.accountService.setPaymentData(this.paymentData);
    this.router.navigate(['../../payment'], { relativeTo: this.route });
  }
}
